import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  VegaFlex,
  VegaModal,
  VegaForm,
  VegaButton,
  VegaProgressTracker,
} from "@heartlandone/vega-react";
import { VegaNotify } from "@heartlandone/vega";
import { HubContext } from 'Redux/Context/context';
import { FORM_NAME } from 'Chore/Constants';
import StepOne from './ActivityForm/StepOne';
import StepTwo from './ActivityForm/StepTwo';
import StepThree from './ActivityForm/StepThree';
import { openFormAction } from 'Redux/Actions/actions';
import {_fetch} from 'Chore/Request';
import { PATH } from 'Chore/Apis';
import StepFour from './ActivityForm/StepFour';
import StepFive from './ActivityForm/StepFive';
const { POST_ACTIVITY,PUT_ACTIVITY } = PATH;

const FINAL_STEP = 2

function ActivityForm({ name = '', activity = {} , finalStep = FINAL_STEP, isEdit = false }) {
  const { formDispatch } = useContext(HubContext);
  const vegaForm = useRef();
  const vegaProgressTracker = useRef();
  const [currentStep, setCurrentStep] = useState(0);
  const [form, setForm] = useState(!!activity.activity ? activity.activity: {});
  const [isOpen, setIsOpen] = useState(false);
  const [progressTrackerStatus, setProgressTrackerStatus] = useState(false);

  useEffect(() => {
    vegaForm.current.setValue(form);
  }, [form]);

  useEffect(() => {
    setIsOpen(name === FORM_NAME['ACTIVITY_FORM']);
  }, [name]);

  const _closeModal = () => {
    formDispatch(openFormAction({ name: '' }));
  }

  const _goToNextStep = () => {
    vegaForm.current.getValue().then(c => {
      setForm({ ...form, ...c});
      vegaProgressTracker.current.nextStep();
      setCurrentStep(currentStep + 1);
    });    
  }

  const _onStepClick = () => {
    vegaForm.current.getValue().then(c => {
      setForm({ ...form, ...c});
    });    
    vegaProgressTracker.current.getCurrent().then(c => {
      setCurrentStep(c);
    });
  }

  useEffect(() => {
    if (currentStep === 0 && !!form?.isStepOneValid === false)
    {
      setProgressTrackerStatus(false);
    }
    else
    {
      setProgressTrackerStatus(true);
    }  
  }, [currentStep,form]);

  const _onSwitchChanged = (key, value) => {
    let newForm = { ...form, [key] : value};
    setForm(newForm);
  }

  const getValue = (value) => {  
    if (value === false || value === null || value === "" || typeof value === 'undefined')
      return false;
    else return true;
  }

  const formatAmount = (number) =>{
    if(number === null || number === undefined || number === "")
      return '0';
    else 
      return number;
  }; 

  const _submit = () => {
    console.log('this is the final step');
    const formData = {
      title: form?.activityTitle,
      startTime : new Date(form?.startDate + (getValue(form?.startTime) ? (' '+ form?.startTime) :'')),
      endTime : new Date(form?.endDate + (getValue(form?.endTime) ? (' ' + form.endTime) : '')),
      // registerDeadline: (getValue(form?.deadlineDate)) ? new Date(form?.deadlineDate + ' 23:59:59'): null,
      registerDeadline: (getValue(form?.deadlineDate)) ? new Date(form?.deadlineDate + ' 23:59:59'):  new Date(form?.startDate + (getValue(form?.startTime) ? (' '+ form?.startTime) :'')),
      isOnlineActivity: getValue(form?.isOnlineActivity),
      chargeType: form?.chargeType,
      chargeAmount : formatAmount(form?.chargeValue),
      city: form?.city,
      location: form?.location,
      category: form?.category,
      publisherCategory: form?.publisherCategory,
      address: form?.address,
      coverId: form?.cover?.id,
      registerNumberLimitType: form?.numberLimitType,
      registerNumberLimit: formatAmount(form?.numberLimitValue),
      descriptionObject: form?.description,
      documentIds: form?.files.map( file => file.id),
      imageIds: form?.images.map(image => image.id),
      registerSetting: {
        isCollectInformation: getValue(form?.isAllowedCollectInfo),
        isNameRequired: getValue(form?.nameRequired),
        isPhoneRequired: getValue(form?.phoneRequired),
        isEmailRequired: getValue(form?.emailRequired),
        isNoteRequired: getValue(form?.noteRequired),
        isAllowInviteGuests: getValue(form?.isAllowedInviteGuests),
        maxInvitedGuests: formatAmount(form?.maxInvitedNumber)
      }      
    }
    
    _fetch({
      method: `${isEdit === true ? 'PUT': 'POST'}`,
      data: formData,
      api: `${isEdit === true? PUT_ACTIVITY(form.activityId) : POST_ACTIVITY}`,
    }).then(res => {

      if(res.code === 2200){
        window.history.back()
        VegaNotify.open({
          type: 'success',
          message: `${isEdit? 'The activity has been updated.': 'The activity has been published.'}`
        });
      }
      else
      {
        VegaNotify.open({
          type: 'error',
          message: res.message
        });
      }
      _closeModal();
    });
  }

  return (
    <VegaModal
      open={isOpen}
      modalTitle={isEdit? 'Edit Activity' : 'Add New Activity'}
      className='w-800'
      style={{ margin: '0 auto' }}
      onVegaClose={_closeModal}
      backdrop='static'
    >
      <VegaProgressTracker
        ref={vegaProgressTracker}
        style={{
          margin: '0 -24px 0 -24px',
          backgroundColor: 'rgb(245,247,247)',
          padding: '16px 0 16px 0',
        }}
        steps={[
          "Basic Info",
          "Date & time",
          "Location",
          "Details",
          "Review & Publish",
        ]}
        direction='horizontal'
        onVegaCurrentStepUpdate={_onStepClick}
        canClickStep= {progressTrackerStatus}
      />
      <VegaForm
        data-vega-form={`form`}
        ref={vegaForm}
      >
        <StepOne currentStep={currentStep} form = {form} callback={_onSwitchChanged} onNextClick={_goToNextStep}/>
        <StepTwo currentStep={currentStep} form = {form} callback={_onSwitchChanged} onNextClick={_goToNextStep}/>
        <StepThree currentStep={currentStep} form ={form} onNextClick={_goToNextStep}/>
        <StepFour currentStep={currentStep} form = {form} callback={_onSwitchChanged} onNextClick={_goToNextStep}/>
        <StepFive currentStep={currentStep} form = {form} callback={_onSwitchChanged}/>
      </VegaForm>
      <VegaFlex justifyContent='end' alignItem={'center'} className='m-t-80 p-t-20 p-l-32 p-r-32 p-b-20 shadow-top border-none' style={{ marginLeft: -24, marginRight: -24, marginBottom: -24 }}>
        <VegaFlex gap={'size-12'}>
          <VegaButton variant="secondary" onVegaClick={_closeModal}>Close</VegaButton>
          {currentStep !== finalStep && <VegaButton disabled={!!form?.isStepOneValid === false} onVegaClick={_goToNextStep} label = {"Next"} />}
          {currentStep === finalStep && <VegaButton onVegaClick={_submit}  label = {"Publish"} />}
        </VegaFlex>
      </VegaFlex>
    </VegaModal>
  );
}

export default ActivityForm;
